import { render } from "./NuevoComentarioModal.vue?vue&type=template&id=77400f88"
import script from "./NuevoComentarioModal.vue?vue&type=script&lang=js"
export * from "./NuevoComentarioModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__